import React, { useEffect } from 'react';
import Contact from '../components/Contact';

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white pt-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 mb-16">
        <h1 className="text-6xl md:text-7xl font-bold mb-6">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-400 to-amber-600">
            Get In Touch
          </span>
        </h1>
        <p className="text-xl text-gray-400 max-w-3xl">
          Let's collaborate on creating something extraordinary. Reach out to discuss your next project.
        </p>
      </div>
      <Contact />
    </div>
  );
};

export default ContactPage;